import { loadModal } from '../../AsyncLoader';
import Component from './ForgotPasswordComponent';


const getModalBody = emailAddress => `
  <div class="tn-success-message" id="tn-account-login-forgot-password-success-message">
    <div class="tn-modal-heading-info">
      <p>${Component.successMessage}</p>
      <div>
        ${Component.emailAddressProvidedLabel}
        ${emailAddress}
      </div>
    </div>
  </div>
`;


async function open({ emailAddress, returnFocusTo }) {
  const Modal = await loadModal();

  Modal.alert({
    returnFocusTo,
    bodyContents: getModalBody(emailAddress),
    title: Component.successMessageSubhead,
    labelBtnAccept: Component.closeButtonText,
  });
}


export default {
  open,
};



// WEBPACK FOOTER //
// ./src/account/login/ForgotPasswordConfirmationModal.js